import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Alert,
  UserService,
  OwnedAssetService,
  ProjectService,
  Spinner,
} from '../../services';
import 'react-tabs/style/react-tabs.css';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-tooltip/dist/react-tooltip.css';
import UserPieCharts from '../../components/UserPieCharts';
import ConfirmationPop from '../../components/ConfirmationPop';
import EditUser from '../../components/users/EditUser';
import ViewUser from '../../components/users/ViewUser';
import TransactionHistory from '../../components/users/TransactionHistory';
import { formatValue } from '../../utils/Helper';
import ManualKycModal from '../../components/users/ManualKycModal';
import AddInvestment from '../../components/users/AddInvestment';
import ConfirmationModal from '../../components/users/ConfirmationModal';
import ProjectListingRootComponent from '../../components/listing/ProjectListingRootComponent';

const UserDetails = () => {
  let params = useParams();
  let userId = params ? params.id : null;
  const [userDetails, setUserDetails] = useState([]);
  const [isDetailsLoader, setDetailsLoader] = useState(true);
  const [showInvestmentModal, setShowInvestmentModal] = useState(false);
  const [isTabStatus, setTabStatus] = useState(1);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [filterFiatData, setFilterFiatData] = useState({
    perPage: 8,
    page: 1,
    commonSearch: '',
    date: '',
    type: '',
    status: '',
    user_id: userId,
  });
  const [filterOnChainData, setFilterOnChainData] = useState({
    perPage: 8,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: '',
    user_id: userId,
    type: '',
  });
  const [ownedAssetLists, setOwnedAssetList] = useState([]);
  const [allProjectsList, setAllProjectsList] = useState([]);
  const [ownedAssetLoading, setOwnedAssetLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [filterOwnedAssetData, setOwnedAssetData] = useState({
    perPage: 5,
    page: 1,
    commonSearch: '',
    sortBy: '',
    investmentType: '',
    user_id: userId,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isCommonConfirmationPop, setCommonConfirmationPop] = useState(false);
  const [isConfirmationPopData, setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });
  const [confirmationData, setConfirmationData] = useState(null);
  const [isPieData, setPieData] = useState(null);
  const [showManualKycModal, setShowManualKycModal] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showBankDetailsConfirmation, setShowBankDetailsConfirmation] =
    useState(false);
  const [sortBy, setSortBy] = useState('');
  const [isDropDownList, setDropDownList] = useState([]);
  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });

  useEffect(() => {
    ownedAssetList();
  }, [filterOwnedAssetData]);
  useEffect(() => {
    setDropDownList([
      {
        name: 'Order by Investment',
        value: '',
      },
      {
        name: 'Big to Small Investment',
        value: 'high_to_low',
      },
      {
        name: 'Small to Big Investment',
        value: 'low_to_high',
      },
    ]);
  }, []);
  const handleEditUser = () => {
    setIsEdit(true);
  };
  const ownedAssetList = async () => {
    try {
      let ownedAssetListRes = await OwnedAssetService.list(
        filterOwnedAssetData.perPage,
        filterOwnedAssetData.page,
        filterOwnedAssetData.commonSearch,
        filterOwnedAssetData.sortBy,
        filterOwnedAssetData.user_id,
        filterOwnedAssetData.investmentType,
      );
      if (ownedAssetListRes.status === 'failure') {
        setOwnedAssetLoading(false);
        Alert.error(ownedAssetListRes.message);
        return false;
      }

      setPieData(ownedAssetListRes.data);
      setPagination({
        totalPages: ownedAssetListRes.data.pagination.totalPages,
        currentPage: ownedAssetListRes.data.pagination.page,
      });
      setOwnedAssetList(ownedAssetListRes.data.records);
      setOwnedAssetLoading(false);
    } catch (error) {
      setOwnedAssetLoading(false);
      Alert.error(error.message);
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      await getUserDetails(userId);
    })();
  }, [filterFiatData, filterOnChainData, isEdit]);

  const getUserDetails = async (userId) => {
    setDetailsLoader(true);
    try {
      let response = await UserService.getUserDetails(userId);
      if (response.status === 'failure') {
        setDetailsLoader(false);
        Alert.error(response.message);
        return false;
      }
      if (response.data.userWallets?.length > 0) {
        response.data.userWallets.sort((a, b) => (a.type < b.type ? 1 : -1));
      }
      if (!response.data.userBankDetail) {
        response.data.userBankDetail = { account_no: null };
      }
      const isAdmin = response.data.roles.some((role) => role.slug === 'admin');

      if (isAdmin) {
        setIsAdmin(1);
      } else {
        setIsAdmin(0);
      }

      setUserDetails(response.data);
      setDetailsLoader(false);
    } catch (error) {
      setDetailsLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = () => {
    if (isTabStatus === 1) {
      setTabStatus(1);
      setFilterFiatData({
        ...filterFiatData,
        page: 1,
        commonSearch: '',
        status: '',
      });
    } else {
      setTabStatus(2);
      setFilterOnChainData({
        ...filterOnChainData,
        page: 1,
        commonSearch: '',
        type: '',
      });
    }
  };

  const makeUserAdmin = async (status) => {
    try {
      Spinner.show();
      let action = 'remove';
      if (status === 0) {
        // user is not admin
        action = 'add';
      }

      const formData = {
        user_id: userId,
        action: action,
      };

      let response = await UserService.makeUserAdmin(formData);
      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }
      Spinner.hide();

      if (action === 'add') {
        setIsAdmin(1);
      } else {
        setIsAdmin(0);
      }

      Alert.success(response.message);
      searchData();
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const handleSelectChange = (status) => {
    let msg1 = '';
    let msg2 = '';
    if (status === 0) {
      msg1 = 'Make Admin';
      msg2 = 'Are you sure you want to promote this user to admin?';
    } else {
      msg1 = 'Remove Admin';
      msg2 = 'Are you sure you want to remove the admin role from this user?';
    }
    setConfirmationPopData({
      FirstText: msg1,
      SecondText: msg2,
      FirstButton: 'No',
      secondButton: 'Yes',
      slug: 'redirect',
    });
    setCommonConfirmationPop(true);
    setConfirmationData({ status });
  };

  const confirmationPopHandel = async (confirmed) => {
    setCommonConfirmationPop(false);
    if (confirmed) {
      const { status } = confirmationData;
      await makeUserAdmin(status);
    }
  };

  const getAllProjects = async () => {
    try {
      const response = await ProjectService.getAllProjects(true);
      if (response?.status === 'failure') {
        Alert.error(response?.message);
        return false;
      }
      setAllProjectsList(response?.data?.records);
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  useEffect(() => {
    getAllProjects(true);
  }, []);

  const handleManualKycSubmit = async ({ userId, manualKycNote }) => {
    try {
      const response = await UserService.updateKycStatus({
        userId,
        manualKycNote,
      });
      if (response.status === 'failure') {
        Alert.error(response.message);
        return;
      }
      Alert.success(response.message);
      setShowManualKycModal(false);
      await getUserDetails(userId);
    } catch (error) {
      Alert.error(error.message || 'Failed to process KYC');
    }
  };

  const handleAddInvestmentClick = () => {
    if (userDetails?.kyc_status === 0) {
      setShowConfirmationDialog(true);
    } else if (!userDetails?.userBankDetail?.account_no) {
      setShowBankDetailsConfirmation(true);
    } else {
      setShowInvestmentModal(true);
    }
  };

  const handleConfirmationDialogConfirm = () => {
    setShowConfirmationDialog(false);
    setShowManualKycModal(true);
  };

  const handleConfirmationDialogClose = () => {
    setShowConfirmationDialog(false);
  };

  const handleBankDetailsConfirmationConfirm = () => {
    setShowBankDetailsConfirmation(false);
    setIsEdit(true);
  };

  const handleBankDetailsConfirmationClose = () => {
    setShowBankDetailsConfirmation(false);
  };
  const searchListData = async (_action, _value) => {
    if (
      _action === 'investmentType' &&
      _value === filterOwnedAssetData.investmentType
    )
      return false;
    setSortBy(_value);
    setOwnedAssetData({
      ...filterOwnedAssetData,
      page: 1,
      [_action]: _value,
    });
  };

  return (
    <div className="">
      {isDetailsLoader && (
        <div>
          <div className="w-full bg-gray-50 rounded-lg p-4 mb-4">
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <Skeleton count={1} height={300} />
            </SkeletonTheme>
          </div>

          <div className="w-full bg-gray-50 rounded-lg p-4 mb-4 grid grid-cols-2 gap-6">
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <Skeleton count={1} height={300} />
            </SkeletonTheme>
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <Skeleton count={1} height={300} />
            </SkeletonTheme>
          </div>
        </div>
      )}

      {isDetailsLoader === false && (
        <ViewUser
          userDetails={userDetails}
          handleEditUser={handleEditUser}
          handleSelectChange={handleSelectChange}
          isEdit={isEdit}
          isAdmin={isAdmin}
          userId={userId}
          refreshUserDetails={getUserDetails}
          kycReasons={
            userDetails?.kycReports[0]?.reasons === ''
              ? JSON.parse(userDetails?.kycReports[0]?.reasons)
              : []
          }
        />
      )}

      <EditUser userId={userId} setIsEdit={setIsEdit} isEdit={isEdit} />

      {isDetailsLoader === false && !isEdit && (
        <div className="xl:grid xl:grid-cols-2 xl:gap-4 mb-4 xl:mb-0">
          <div className="flex justify-between items-center bg-brandGray px-4 py-4 rounded-md">
            <div className="flex flex-col justify-evenly">
              <div>
                <h5 className="text-base mb-2">Total Projects</h5>
                <p className=" text-2xl font-semibold">
                  {userDetails?.totalInvestedProjects
                    ? userDetails.totalInvestedProjects
                    : '0'}
                </p>
              </div>

              <div>
                <h5 className="mt-6 text-base mb-2">Total Invested</h5>
                <p className=" text-2xl font-semibold">
                  {userDetails?.totalInvestMent
                    ? formatValue(userDetails?.totalInvestMent, {
                        decimalPlaces: 2,
                      })
                    : '0'}
                </p>
              </div>
            </div>
            {ownedAssetLists && ownedAssetLists?.length > 0 && (
              <div className="">
                <UserPieCharts chartList={isPieData.projectType} />
              </div>
            )}
            {ownedAssetLists && ownedAssetLists?.length === 0 && (
              <div className="px-5">
                <img src="/img/pie-dummy.png" className="" alt="" />
              </div>
            )}
          </div>

          <div className="flex justify-between  bg-brandGray px-4 py-4 rounded-md">
            <div className="mt-6">
              <h5 className="text-base mb-2">Total Interest Received</h5>
              <p className=" text-2xl font-semibold">
                {userDetails?.total_paid_payout_amount
                  ? formatValue(userDetails?.total_paid_payout_amount, {
                      decimalPlaces: 2,
                    })
                  : 0.0}
              </p>
            </div>
            {isPieData && isPieData?.total_paid_payout_amount !== null && (
              <div className="">
                <UserPieCharts chartList={isPieData?.user_payouts} />
              </div>
            )}
            {isPieData && isPieData?.total_paid_payout_amount === null && (
              <div className="px-5">
                <img src="/img/pie-dummy.png" className="" alt="" />
              </div>
            )}
          </div>
        </div>
      )}

      {ownedAssetLists && !isEdit && (
        <div className="bg-brandGray px-4 py-4 mt-6">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="mb-4 lg:mb-0">Investments</h3>
            </div>
            <div>
              <div className="flex gap-2">
                <button
                  onClick={handleAddInvestmentClick}
                  className="bg-brandBlue w-full text-white text-sm font-semibold rounded-md px-4 py-2 flex items-center justify-center whitespace-nowrap"
                >
                  Add Investment
                </button>
              </div>
            </div>
          </div>
          <ProjectListingRootComponent
            projectLists={ownedAssetLists}
            slug="user-investments"
            projectLoading={ownedAssetLoading}
            searchData={searchListData}
            isDropDownList={isDropDownList}
            value={sortBy}
            filterData={filterOwnedAssetData}
            setFilterData={setOwnedAssetData}
            isPagination={isPagination}
            setPagination={setPagination}
            isListLoader={ownedAssetLoading}
            list={ownedAssetList}
          />
        </div>
      )}

      <ManualKycModal
        isOpen={showManualKycModal}
        onClose={() => setShowManualKycModal(false)}
        onSubmit={handleManualKycSubmit}
        userId={userId}
      />

      <AddInvestment
        isOpen={showInvestmentModal}
        onClose={() => {
          setShowInvestmentModal(false);
        }}
        allProjectsList={allProjectsList}
        userId={userId}
        userDetails={userDetails}
        ownedAssetList={ownedAssetList}
        getUserDetails={getUserDetails}
        setRefreshTrigger={setRefreshTrigger}
      />
      <ConfirmationModal
        isOpen={showConfirmationDialog}
        onClose={handleConfirmationDialogClose}
        onConfirm={handleConfirmationDialogConfirm}
        title="KYC Required"
        message="Do you want to complete the KYC manually?"
        confirmButtonText="Yes"
        cancelButtonText="No"
      />
      <ConfirmationModal
        isOpen={showBankDetailsConfirmation}
        onClose={handleBankDetailsConfirmationClose}
        onConfirm={handleBankDetailsConfirmationConfirm}
        title="Bank Details Required"
        message="Do you want to update the users bank account details?"
        confirmButtonText="Yes"
        cancelButtonText="No"
      />

      {!isEdit && (
        <>
          <TransactionHistory
            isTabStatus={isTabStatus}
            setTabStatus={setTabStatus}
            filterFiatData={filterFiatData}
            setFilterFiatData={setFilterFiatData}
            filterOnChainData={filterOnChainData}
            setFilterOnChainData={setFilterOnChainData}
            searchData={searchData}
            userId={userId}
            refreshTrigger={refreshTrigger}
          />
          <ConfirmationPop
            isPop={isCommonConfirmationPop}
            setPop={setCommonConfirmationPop}
            functionCall={confirmationPopHandel}
            FirstText={isConfirmationPopData.FirstText}
            secondText={isConfirmationPopData.SecondText}
            FirstButton={isConfirmationPopData.FirstButton}
            secondButton={isConfirmationPopData.secondButton}
            slug={isConfirmationPopData.slug}
          />
        </>
      )}
    </div>
  );
};

export default UserDetails;
